import { Component, Injector, Input, OnInit } from '@angular/core';
import { take } from 'rxjs';
import { ObjectUtil } from '../../../../../components/common/object-util/object-util';
import { WidgetDynamicBaseComponent } from '../../widgetDynamicBase';

@Component({
  selector: 'sales-grid-widget',
  templateUrl: './sales-grid-widget.component.html',
  styleUrls: ['../../common/css/general.scss', './sales-grid-widget.component.scss']
})
export class SalesGridWidgetComponent extends WidgetDynamicBaseComponent implements OnInit {

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  public compCount: number;

  public compColSpan: number;

  public labelColSpan: number;

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useDefaultServiceSaveChangesHandler("salesGrid", this.provideSaveObject.bind(this));
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    if (!this.widgetConfig.hashtagSupported) {
      this.widgetConfig.hashtagSupported = true;
    }

    this.mockupData$ = this.widgetService.loadMockup('salesGrid').pipe(take(1));

    this.widgetData$ = this.mockup ?
      this.mockupData$
      : this.widgetService.load('salesGrid', this.getReport()).pipe();
  }

  /**
   * Constructor
   * @param injector
   */
  constructor(injector: Injector) {
    super(injector, 'salesGrid', false);
  }

  /**
  * Initializes the component
  */
  ngOnInit(): void {
    this.initWidgetConfig();
    this.widgetResized();
  }

  /**
   * Pre-process the loaded data.Override if needed
   * @param data The loaded data
   */
  protected preprocessLoadedData(data): any {

    data.processedData = {rowData: []};

    if (data.rows.length) {
      data.bottomRows = {
        usSalesGridRangeComparablesUnadjusted: data.usSalesGridRangeComparablesUnadjusted,
        usSalesGridAverageComparablesUnadjusted: data.usSalesGridAverageComparablesUnadjusted,
        usSalesGridMedianComparablesUnadjusted: data.usSalesGridMedianComparablesUnadjusted,
        usSalesGridRangeComparablesAdjusted: data.usSalesGridRangeComparablesAdjusted,
        usSalesGridAverageComparablesAdjusted: data.usSalesGridAverageComparablesAdjusted,
        usSalesGridMedianComparablesAdjusted: data.usSalesGridMedianComparablesAdjusted,
        usSalesGridReconciledUnitValue: data.usSalesGridReconciledUnitValue
      };

      for (let i = 1; i <= 82; ++i) {
        try {
          data.processedData.rowData[i - 1] = [];
          const rowsMatching = data.rows.filter((row) => row.index === i);
          for (const row of rowsMatching) {
            data.processedData.rowData[i - 1].push(row)
          }
        } catch (e) {
          break;
        }
      }

      data.processedData.rowData = data.processedData.rowData.filter(pd => { return !this.allValuesAreNull(pd); });
    }

    return data;
  }

  /**
   * Called by base class in save process. Widget should return object to be saved
   */
  async provideSaveObject(): Promise<any> {
    const data = ObjectUtil.deepCopy(this.widgetData);//deep copy

    return data;
  }

  allValuesAreNull(array: any[]): boolean {
    for (const obj of array) {
      if (obj.numberFormat !== null && (obj.dateValue !== null || obj.decimalValue !== null || obj.textValue !== null || obj.intValue !== null))
        return false;
    }
    return true; // If all values are null, return true
  }

  public getMinimumRowIndex(): number {
    return 1;
  }

  public getMaximumRowIndex(): number {
    if (this.widgetData) {
      return this.widgetData.processedData?.rowData?.length + 8;
    }
    return -1;
  }

  public moreColumnsRequestedIfOnPortraitPage(): boolean {
    return false;
  }
}
